export const PRIMARY_THEME_COLOR = "#3B4760";
export const WHITE_THEME_COLOR = "#FFFFFF";
export const WARNING_THEME_COLOR = "#D03931";
